<template>
    <div class="show-modal-link__container">
        <p class="show-modal-link" @click="showModal">{{ text }}</p>
        <modal
            :name="uniqueModalName"
            width="50%"
            height="auto">
            <div class="modal__content">
                <slot>

                </slot>
                <div class="modal__footer">
                    <button class="btn btn--hollow btn--block btn--small" @click="closeModal">
                        {{ closeButtonText }}
                    </button>
                </div>
            </div>

        </modal>
    </div>
</template>

<script>
    export default {
        props: {
            id: [String, Number],
            text: String,
            modalName: String,
            closeButtonText: String,
        },
        methods: {
            showModal() {
                this.$modal.show(this.uniqueModalName);
            },
            closeModal() {
                this.$modal.hide(this.uniqueModalName);
            }
        },
        computed: {
            uniqueModalName() {
                return `${this.modalName}-${this.id}`;
            }
        }
    };
</script>
